import { render, staticRenderFns } from "./Curtain.vue?vue&type=template&id=72278f23"
import script from "./Curtain.vue?vue&type=script&lang=js"
export * from "./Curtain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports